import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M3 6v7.5h6c0 1.664-1.336 3-3 3V18c2.476 0 4.5-2.024 4.5-4.5V6H3Zm10.5 0v7.5h6c0 1.664-1.336 3-3 3V18c2.476 0 4.5-2.024 4.5-4.5V6h-7.5Zm-9 1.5H9V12H4.5V7.5Zm10.5 0h4.5V12H15V7.5Z" />
  </svg>
);

export default icon;
